<template>
  <v-card
    style="min-width:816px; max-width:816px; min-height:816px; min-height:1056px"
    class="pa-8 mb-4"
    elevation="5"
  >
    <slot name="content" />
  </v-card>
</template>

<script>
export default {
  name: 'ChecklistVirtualPage',
}
</script>
